// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Anastasia Checnovskaya <anastasia.chesnovskaya@celadon.ae>
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { withStyles } from '@material-ui/core';

import { Loader } from '../../../../../../components';
import { getOrder } from '../OrderFull/store/selectors';
import * as orderDetailsActions from '../OrderFull/store/actions';
import { NearestPostcodeDesktop, NearestPostcodeMobile } from './components';
import styles from './styles';

class OrderNearestPostcode extends Component {
  static propTypes = {
    classes: PropTypes.object,
    requestOrder: PropTypes.func,
    order: PropTypes.any,
    history: PropTypes.any,
    resetOrder: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    requestOrder: () => { },
    resetOrder: () => { },
    order: null,
    history: null,
  };

  componentDidMount() {
    const { history } = this.props;
    const token = localStorage.getItem('token');
    const id = localStorage.getItem('loggedID');
    const orderId = history.location.state.id;
    this.props.requestOrder({ token, id, orderId });
  }

  componentWillUnmount() {
    this.props.resetOrder();
  }

  render() {
    const { order, classes } = this.props;

    return (
      order ? (
        <MediaQuery minWidth={600}>
          {matches => (matches
            ? <NearestPostcodeDesktop order={order} />
            : <NearestPostcodeMobile order={order} />)}
        </MediaQuery>)
        : <div className={classes.loaderContainer}><Loader /></div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    order: getOrder(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    requestOrder: data => dispatch(orderDetailsActions.requestOrderDetails(data)),
    resetOrder: () => dispatch(orderDetailsActions.resetOrder()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(OrderNearestPostcode));
